import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Dilucion`, method: 'GET', body: null, token: token})
}
